import { render, staticRenderFns } from "./DefaultChapterEntryList.vue?vue&type=template&id=63e1e24d&"
import script from "./DefaultChapterEntryList.vue?vue&type=script&lang=js&"
export * from "./DefaultChapterEntryList.vue?vue&type=script&lang=js&"
import style0 from "./DefaultChapterEntryList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports